<template>
  <div>
    <div v-if="siteBookingSettingServiceSelectEnabled && siteBookingSettingDisplayServicePrices" class="d-flex w-100 justify-content-between mt-2">
      <div class="font-weight-bold mt-2">Total:</div>
      <div class="font-weight-bold">{{ currencySymbol }}{{ totalAmount }}</div>
    </div>
    <div v-if="siteBookingSettingDisplayBookingDuration && shouldDisplayDuration" class="small">
      {{ durationLabel }}: {{ formattedDurationString }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formatDuration } from '@/helpers/DurationHelper'
import { CountryCacheMixin } from '@/mixins/Booking/CountryCacheMixin'
import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin'

export default {
  name: 'TotalAmount',
  mixins: [CountryCacheMixin, SiteBookingSettingMixin],
  computed: {
    ...mapState('BookingUpload', [
      'selectedPets',
      'duration',
      'stackGroupBooking'
    ]),
    totalAmount () {
      const total = this.selectedPets.reduce((petSum, pet) => {
        const servicesTotal = pet.serviceItems.reduce(
          (sum, item) => sum + item.amount,
          0
        )
        return petSum + servicesTotal
      }, 0)

      return total.toFixed(2)
    },
    slotDurationMinutes () {
      return this.stackGroupBooking
        ? (this.selectedPets ?? []).reduce((sum, { appointmentDuration = 0 }) => sum + (appointmentDuration === 0 ? this.duration : appointmentDuration), 0)
        : this.duration
    },
    shouldDisplayDuration () {
      if (this.stackGroupBooking) {
        return (this.selectedPets ?? []).every(pet => pet.appointmentDuration > 0)
      }
      return (this.selectedPets ?? []).length > 1
    },
    durationLabel () {
      return this.stackGroupBooking ? 'Total Duration' : 'Group Duration'
    },
    formattedDurationString () {
      return formatDuration(this.stackGroupBooking ? this.slotDurationMinutes : this.duration)
    }
  }
}
</script>
